import { render, staticRenderFns } from "./TagGroup.vue?vue&type=template&id=8bd84aca&scoped=true&"
import script from "./TagGroup.vue?vue&type=script&lang=js&"
export * from "./TagGroup.vue?vue&type=script&lang=js&"
import style0 from "./TagGroup.vue?vue&type=style&index=0&id=8bd84aca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd84aca",
  null
  
)

export default component.exports